import { ERef } from '.';
import { InvoiceTransaction } from './invoiceTransaction';

/** TODO: Support more transaction types */
export enum NewspaperOrderTransactionType {
  REFUND = 'refund'
}

export enum NewspaperOrderTransactionStatus {
  PENDING = 'pending',
  COMPLETE = 'complete',
  CANCELLED = 'cancelled'
}

/**
 * NewspaperOrderTransaction is the proportional impact of an InvoiceTransaction on a particular newspaper order
 */
export type NewspaperOrderTransaction = {
  /** invoiceTransaction of the completed transaction.  Not present until payment processing operation completes */
  invoiceTransaction?: ERef<InvoiceTransaction>;
  /** Total amount attributed to this newspaper order for the transaction (e.g. refund amount) */
  newspaperOrderAmountInCents: number;
  /** Portion impacting publisher transfer */
  publisherPortionInCents: number;
  /** Portion impacting tax */
  taxPortionInCents: number;
  /** Portion impacting Column convenience fee */
  convenienceFeePortionInCents: number;
  /** Portion impacting Column application fee */
  applicationFeePortionInCents?: number;
  type: NewspaperOrderTransactionType;
  status: NewspaperOrderTransactionStatus;
  reason?: string;
};
